import Http from "./HttpService";

import { DEFAULT_LIMIT, DEFAULT_OFFSET } from "../constants/pagination";

class VideoLibraryService extends Http {
  BASE_URL = "/admins/video-library";

  getList(params) {
    // const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`${this.BASE_URL}`, {
      params
    });
  }

  async getOne(id) {
    const { data } = await this.get(`${this.BASE_URL}/${id}`);
    // if (!data.video) {
    //   return { data };
    // }
    const initialFile = data;
    initialFile.preview = data.videoPreview || null;
    initialFile.size = null;

    if (initialFile?.thumbnailImage) {
      initialFile.thumbnailImage.preview = initialFile.thumbnailImage.link;
      initialFile.thumbnailImage.size = null;
    }

    return { data: { ...data, initialFile } };
  }

    /**
   * Upsert video thumbnail
   * @param {{filesId: number, videoThumbnailId}} model is an object with file id and video thumbnail id;
   * */
    upsertVideoThumbnail(model) {
      return this.post(`${this.BASE_URL}/upsert-video-thumbnail`, model, { disableToast: true });
    }

    update(id, model) {
      return this.put(`${this.BASE_URL}/${id}`, model);
    }

    remove(id) {
      return this.delete(`${this.BASE_URL}/${id}`);
    }

    exportVideoLibraryReport() {
      return this.post(`${this.BASE_URL}/export-video-library-report`);
    }
}

export default new VideoLibraryService();